/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type EvmHomeTotalTrxCountInfo = {
    TRXTP: EvmHomeTotalTrxCountInfo.TRXTP;
    TTRXCNT: string;
};

export namespace EvmHomeTotalTrxCountInfo {

    export enum TRXTP {
        NORMAL = 'NORMAL',
        INTERNAL = 'INTERNAL',
        PENDING = 'PENDING',
    }


}

